import React from "react";
import { getColorByCollectStatusId, getColorByShippingStatusId } from "../../../utils/getIconAndColor";

export default function CustomMapMarkerPackages({ loc }) {
  const icon = loc?.isOriginDestination ? loc?.origin_or_destination?.charAt(0)?.toUpperCase() : loc?.order

  const handleBackgroundColor = () => {
    if (loc?.isOriginDestination) {
      return "#000"
    } else {
      const icon = loc?.isOwnCollect ? getColorByCollectStatusId(loc?.status) : getColorByShippingStatusId(loc?.status)
      return icon.color
    }
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "24px",
        height: "24px",
        backgroundColor: handleBackgroundColor(),
        color: "white",
        fontWeight: "bold",
        borderRadius: "50% 50% 50% 0",
        transform: "rotate(-45deg)",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          transform: "rotate(45deg)",
          fontSize: (icon === 1 || loc?.isOriginDestination) ? "14px" : "12px"
        }}
      >
        {icon}
      </div>
    </div>
  )
}